/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
*/

// App Requires
require('./app/primary-navigation');
require('./app/accordions');
require('./app/collapse');
require('./app/dropdowns');
require('./app/tabs');
require('./app/image-crossfade');
require('./app/feature-crossfade');


require('./app/swiper/carousel');
require('./app/swiper/info-slider');
require('./app/gform-override');
// require('./app/animations');
require('./app/revealProjects');
require('./app/vendor/isotope.min');
require('./app/revealStories');
require('./app/smooth-scroll');
require('./app/sticky-projects');

// Animation Requires
require('./app/animation/global');
require('./app/animation/homepage');
require('./app/animation/locations');

